import { useState } from "react"
import { Input } from "../../components/input.js"
import { Button } from "../../components/button.js"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/select.js"
import type { SubSubGroup } from "./data-table.js"

type Props = {
  onSubmit: (data: any) => void
  initialValues?: Partial<SubSubGroup>
  groupValues?: Partial<SubSubGroup>
  isEdit?: boolean
}

export function SubSubGroupForm({ onSubmit, initialValues = {}, groupValues = {}, isEdit = false }: Props) {
  const [form, setForm] = useState({
    name: initialValues?.name || "",
    status: initialValues?.status || "1",
    sub_group_id: initialValues?.sub_group_id ? String(initialValues.sub_group_id) : "",
    code: initialValues?.code || "",
  })
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleStatusChange = (value: string) => {
    setForm({ ...form, status: value })
  }

  const handleGroupChange = (value: string) => {
    setForm({ ...form, sub_group_id: value })
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    const {
      name,
    } = form;

    const errors = [];

    if (!name) errors.push("Name is required.");

    if (errors.length > 0) {
      alert(errors.join("\n"));
      return;
    }
    
    onSubmit(form)
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4 py-4">
      <Input name="name" placeholder="Name" value={form.name} onChange={handleChange} />
      <Input name="code" placeholder="Code" value={form.code} onChange={handleChange} />
      {Array.isArray(groupValues) ?
      <Select value={form.sub_group_id} onValueChange={handleGroupChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select Group" />
        </SelectTrigger>
        <SelectContent>
            {groupValues.map((option) => (
              <SelectItem key={option.sub_group_id} value={String(option.sub_group_id)}>
                {option.name}
              </SelectItem>
            ))}
        </SelectContent>
      </Select>
      :""}
      <Select value={form.status} onValueChange={handleStatusChange}>
        <SelectTrigger>
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="1">Enabled</SelectItem>
          <SelectItem value="0">Disabled</SelectItem>
        </SelectContent>
      </Select>

      <Button type="submit">{isEdit ? "Update Sub Sub Group" : "Add Sub Sub Group"}</Button>
    </form>
  )
}
